import React, { useState } from 'react';
import { UserCourseService } from '@services/index';
import { useSnackbar } from '@components/utilities/SnackbarProvider';

async function updateEntity(payload, Entity) {
  const entityService = new Entity();
  const entityResponse = await entityService.update(payload);

  if (!entityResponse || !entityResponse.result) {
    return null;
  }

  return entityResponse;
}

const UserCourseBlock = (props) => {
  const { selectedEntity, setIsOpen } = props;
  const { openSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);

  const confirmOnClick = async () => {
    try {
      setIsLoading(true);
      const status = { id: 4, name: 'blocked', title: 'Bloqueado' };
      const response = await updateEntity(
        { id: selectedEntity.usercourse_id, status },
        UserCourseService,
      );

      if (!response || !response.success) {
        openSnackbar('Ocurrio un error al bloquear', 'error');
        return;
      }

      setIsOpen(false);
      openSnackbar('Actualización exitosa!', 'success');
    } catch (error) {
      openSnackbar('Ha ocurrido un error', 'error');
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const returnOnClick = () => {
    setIsOpen(false);
  };

  return (
    <section className="col-12 mx-auto d-block">
      <div className="card card-body">
        <article className="container pt-2 text-center">
          <h2 className="mb-2">¿Estás seguro?</h2>
          <p className="fs-5">
            Bloquear pago 
          </p>
          <div className="mt-4">
            {isLoading ? (
              <button class="btn btn-primary" disabled type="button">
                <span
                  class="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </button>
            ) : (
              <>
                <button
                  className="btn btn-primary mr-2"
                  onClick={confirmOnClick}
                >
                  <i className="fe-shield-off"></i> Bloquear
                </button>
                <button
                  className="btn btn-light btn-action ms-2"
                  onClick={returnOnClick}
                >
                  <i className="fe-x"></i> Cancelar
                </button>
              </>
            )}
          </div>
        </article>
      </div>
    </section>
  );
};

export default UserCourseBlock;
